var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_settings)?_c('content-data',{attrs:{"list":_vm.list_id,"editpath":"/billing/contracts/list/","disable-import":"","search":_vm.search}}):_vm._e(),_c('action-buttons',{on:{"add":_vm.open_add}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }